import Vue from 'vue'
import App from './App'
import router from './router'
import axios from "axios";
import store from './store'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: null,
  loading: require('./assets/images/loading.gif'),
  attempt: 1
})

Vue.config.productionTip = false
const apiURL = 'https://memoria.sg/api'

store.subscribe((mutation, state) => {
  localStorage.setItem('store_memoria_pwa', JSON.stringify(state));
});

new Vue({
  el: '#app',
  data() {
    return {
      loading: false,
      jsonData: null
    }
  },
  store,
  beforeCreate() {
    this.$store.commit('initialiseStore');
  },
  mounted(){
  this.fetchData()
  },
  created(){

  },
  methods: {
      fetchData () {
        axios.get(apiURL)
          .then(response => this.jsonData = response.data)
          .then(response => this.$store.commit('setJsonData', this.jsonData ))
          .then(function (response) {
               console.log("loaded")
        })
      },
  },
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js